let YandexMap = require('ymaps').default;

class Map
{
    constructor(container, center, apiKey, params = {}, zoom = 16) {
        return YandexMap.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=' + apiKey).then(api => {
            this.api = api;
            this.map = new api.Map(container, {
                ...params,
                ...{center, zoom}
            }, { suppressMapOpenBlock: true });

            return this;
        });
    }

    makePlacemark(coords, preset, iconCaption = null, openEmptyBalloon = false) {
        return new this.api.Placemark(coords, { iconCaption }, { openEmptyBalloon, preset });
    }

    setAutoLocation(autoCenter = false) {
        return this.api.geolocation.get({ mapStateAutoApply: autoCenter }).then(result => {
            result.geoObjects.get(0).properties.set({
                balloonContentBody: '�� ��������������'
            });

            this.map.geoObjects.add(result.geoObjects);

            return result;
        });
    }
}

module.exports = Map;